<template>
  <div style="margin: 0 16px;">
    <el-input v-model="refusalReason" placeholder="请输入驳回原因" type="textarea" :rows="8"/>
  </div>
  <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
    <el-button @click.native="cancel" >取消</el-button>
    <el-button type="primary" @click="summit">确定</el-button>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updatePurchaseState} from "@/api/url";

export default {
  name: "RefusalReasonDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArr: this.value.idArr,
      stockId: this.value.stockId,
      refusalReason: ''
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    summit() {
      let param = {}
      param['idArr'] = this.idArr
      param['stockId'] = this.stockId
      param['refusalReason'] = this.refusalReason;
      param['state'] = 2
      postFormData(updatePurchaseState, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

  }
}
</script>

<style scoped>

</style>
